<script setup lang="ts">
import IconArrowDown from '@/assets/icons/arrow-down.svg'
import IconArrowUp from '@/assets/icons/arrow-up.svg'

defineProps(['params'])
</script>

<template>
  <component
    v-if="params?.data?.priority >= 3"
    :is="IconArrowUp"
    class="fill-current text-center text-success h-max"
  />
  <component v-else :is="IconArrowDown" class="fill-current text-error" />
</template>
